import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.62 9.62h-5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.25a.749.749 0 1 1 0 1.5M7.12 10.38c-.19 0-.38-.07-.53-.22l-.75-.75a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.22.22 1.72-1.72c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-2.25 2.25a.75.75 0 0 1-.53.22M17.62 16.62h-5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.25a.749.749 0 1 1 0 1.5M7.12 17.38c-.19 0-.38-.07-.53-.22l-.75-.75a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.22.22 1.72-1.72c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-2.25 2.25a.75.75 0 0 1-.53.22" }, null, -1),
    _createElementVNode("path", { d: "M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75m-6-20C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25z" }, null, -1)
  ]))]))
}
export default { render: render }